<span class="inline-flex items-center gap-1.5 text-sm">
  @if (value()) {
    <mat-icon
      class="!text-xl !w-5 !h-5 !leading-5 !text-green-600 dark:!text-green-400"
      [matTooltip]="'generic.yes' | translate"
      [attr.aria-label]="'generic.yes' | translate">check_circle</mat-icon>
    @if (label(); as l) {
      <span>{{ l }}</span>
    }
  } @else {
    <mat-icon
      class="!text-xl !w-5 !h-5 !leading-5 !text-gray-400 dark:!text-gray-500"
      [matTooltip]="'generic.no' | translate"
      [attr.aria-label]="'generic.no' | translate">remove</mat-icon>
    @if (label(); as l) {
      <span class="text-gray-400 dark:text-gray-500">{{ l }}</span>
    }
  }
</span>
